import Icon from 'veui/components/Icon'

Icon.register({
  'protection-internal': {
    paths: [
      {
        d: 'M678.94 96.76l-288.06-64a32.17 32.17 0 00-13.88 0l-288 64a32 32 0 00-25 33.63l31.11 416a32 32 0 0015 24.77l257 160a32 32 0 0033.87 0L657 571.14a32 32 0 0014.95-24.69l32-416a32 32 0 00-25.01-33.69zm-69.61 428.67L383.92 666.29 157.7 525.42l-27.83-372.19 254.07-56.45 254 56.44zM360.46 175.85v44.82H239.18v288.89h46.7v-99.44l20.72 24.11q28.62-22.22 47.83-42.75a207.45 207.45 0 0031.27-42.75q9 9 18.64 19.4t19.21 20.71q9.6 10.37 18.45 20.53t15.63 19.21l24.11-32V441q0 12.06-4 16t-17.13 5.47l-28.25 3 15.82 46.33 29.38-3a166.29 166.29 0 0025.8-4.14q10-2.64 15.63-8.1a28.45 28.45 0 007.72-14.5q2.07-9 2.07-23.35v-238h-122v-42.98zm-5.65 124.29A117.85 117.85 0 01342 330.09a146.42 146.42 0 01-22.41 28.24A249.92 249.92 0 01285.88 386V267h74.2a169.21 169.21 0 01-5.27 33.14zM481.74 267v113.37q-7.55-8.67-17.52-19t-20.71-20.91Q432.77 329.91 422 320.1t-19.77-17.7a167.41 167.41 0 002.82-17.32q.95-8.67 1.32-18.08z'
      }
    ],
    width: '768',
    height: '768'
  }
})
